import { Injectable } from '@angular/core';
import { FolderData } from '@app/stores/foldersStore';
import { DeliveryNoteInPool } from 'api/models';

@Injectable({
    providedIn: 'root',
})
export class CheckoutBundleService {
    selection: FolderData[];

    private newBundleSelection: DeliveryNoteInPool[];

    constructor() {}

    public get getNewBundleSelection() {
        return this.newBundleSelection;
    }

    public setNewBundleSelection(selection: DeliveryNoteInPool[]) {
        this.newBundleSelection = selection;
    }
}
